import yVaultV2 from "./abi/yVaultV2.json";
import LidoVault from "./abi/LidoVault.json";

// Main config file for common parameters
export default Object.freeze({
  yusdcidle: {
    // route path
    TITLE: "USDc Idle",
    LOGO: "🏆🚀",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x33bd0f9618cf38fea8f7f01e1514ab63b9bde64b",
    WANT_ADDR: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    WANT_SYMBOL: "USDC",
    COINGECKO_SYMBOL: "usd-coin",
    VAULT_DEV: "emilianobonassi",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  titanironslp: {
    // route path
    TITLE: "TITAN-IRON SLP",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x607da5d25515e8a931f4e23f03dd62b8ad1f23a6",
    WANT_ADDR: "0x35c1895dac1e2432b320e2927b4f71a0d995602f",
    WANT_SYMBOL: "TITAN-IRON SLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 137,
  },
  matictitanslp: {
    // route path
    TITLE: "Matic TITAN SLP",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x185D62a235986e3800CF356F765271064684e73c",
    WANT_ADDR: "0xA79983Daf2A92c2C902cD74217Efe3D8AF9Fba2a",
    WANT_SYMBOL: "MATIC-IRON SLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 137,
  },
  usdcironslp: {
    // route path
    TITLE: "USDC IRON SLP",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x4669c79De668adc439069ea32C3c99A6c37b8088",
    WANT_ADDR: "0x85dE135fF062Df790A5f20B79120f17D3da63b2d",
    WANT_SYMBOL: "MATIC-IRON SLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 137,
  },
  usdcironqlp: {
    // route path
    TITLE: "USDC IRON QLP",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x7E5D7C667Bb769435439d7B7dc9dA38cCd4163Cc",
    WANT_ADDR: "0x2Bbe0F728f4d5821F84eeE0432D2A4be7C0cB7Fc",
    WANT_SYMBOL: "USDC-IRON QLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 137,
  },

  kubeanskuswaplp: {
    // route path
    TITLE: "KuBeans-WKCS Kuswap",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xb15E79B57EA3B7D1b34374c9CDEcF8a4389B8E92",
    WANT_ADDR: "0x922a3fc7dAc0E6b3BA973a5c323Ff8D536359102",
    WANT_SYMBOL: "KuBeans-WKCS KuLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT:true,
    CHAIN_ID: 321,
  },
  kubeanskoffeeswaplp: {
    // route path
    TITLE: "KuBeans-WKCS Koffeeswap",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x160df063eB86513D3d913092d6c6013C3314EA85",
    WANT_ADDR: "0x7a1ec7140832345E822d9B6bBfa8710FDE010993",
    WANT_SYMBOL: "KuBeans-WKCS KuLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT:true,
    CHAIN_ID: 321,
  },
  kcskuslp: {
    // route path
    TITLE: "Kuswap LP Compounder",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x4817c072dB65a0B6497C811804FdCd1e9E55C7c3",
    WANT_ADDR: "0x1EE6b0F7302b3c48c5Fa89Cd0a066309D9AC3584",
    WANT_SYMBOL: "KCS-KUS LP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT:true,
    CHAIN_ID: 321,
  },
  kusStaker: {
    // route path
    TITLE: "Kuswap Staker",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xD226d4616452ffB96370eEd11BF22239b35fB5c0",
    WANT_ADDR: "0x4A81704d8C16d9FB0d7f61B747D0B5a272badf14",
    WANT_SYMBOL: "KUS",
    COINGECKO_SYMBOL: "kuswap",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: false,
    CHAIN_ID: 321,
  },
  usdtkcskuswap: {
    // route path
    TITLE: "USDT-WKCS Kuswap",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x5321bb6d8ecec291ba146df06da5d30ea650ba03",
    WANT_ADDR: "0x6c31e0f5c07b81a87120cc58c4dcc3fbafb00367",
    WANT_SYMBOL: "USDT-WKCS KuLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 321,
  },
  cheokex: {
    TITLE: "CHE yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0xe92f6C4333A5e1522a047B1a60d27B9F90321537",
    WANT_ADDR: "0x8179D97Eb6488860d816e3EcAFE694a4153F216c",
    WANT_SYMBOL: "CHE",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexus",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: false,
    CHAIN_ID: 66
  },
  usdtokexTestOld: {
    TITLE: "USDT Vault Test Old",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x2CB643Bf28897CeB14c614aE60BDf546ebea0224",
    WANT_ADDR: "0x382bB369d343125BfB2117af9c149795C6C65C50",
    WANT_SYMBOL: "USDT",
    COINGECKO_SYMBOL: "tether",
    VAULT_DEV: "akshaynexus",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: false,
    CHAIN_ID: 66
  },
  usdtokexTest: {
    TITLE: "USDT Vault Test",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0xcFa5402299d0facAbcb796d72E9A894165D577B2",
    WANT_ADDR: "0x382bB369d343125BfB2117af9c149795C6C65C50",
    WANT_SYMBOL: "USDT",
    COINGECKO_SYMBOL: "tether",
    VAULT_DEV: "akshaynexus",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: false,
    CHAIN_ID: 66
  },
  usdtokex: {
    TITLE: "USDT Vault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x0DE1363ca50663BA964b6E30ca13D799ed82e8C2",
    WANT_ADDR: "0x382bB369d343125BfB2117af9c149795C6C65C50",
    WANT_SYMBOL: "USDT",
    COINGECKO_SYMBOL: "tether",
    VAULT_DEV: "akshaynexus",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: false,
    CHAIN_ID: 66
  },
  chewoktche: {
    TITLE: "CHE-WOKT CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x46802E1bbd657309955294963cAD1074E977d40E",
    WANT_ADDR: "0x8E68C0216562BCEA5523b27ec6B9B6e1cCcBbf88",
    WANT_SYMBOL: "CHE-WOKT CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  usdtcheche: {
    TITLE: "USDT-CHE CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x09eCca65a2269E040EBfB80DED43fC99459C1C1e",
    WANT_ADDR: "0x089dedbFD12F2aD990c55A2F1061b8Ad986bFF88",
    WANT_SYMBOL: "USDT-CHE CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  usdtwoktche: {
    TITLE: "USDT-WOKT CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0xFD80B6e46e12cEE3313499536267a33394AAA1a6",
    WANT_ADDR: "0xF3098211d012fF5380A03D80f150Ac6E5753caA8",
    WANT_SYMBOL: "USDT-WOKT CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  usdtbtckche: {
    TITLE: "USDT-BTCK CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0xaB8D63754D0970E81FB0fB6e22D67cb27300D7Cd",
    WANT_ADDR: "0x94E01843825eF85Ee183A711Fa7AE0C5701A731a",
    WANT_SYMBOL: "USDT-BTCK CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  usdtethkche: {
    TITLE: "USDT-ETHK CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x94d44D9F7ef92c8E994605C86bB18B6927F0c6a2",
    WANT_ADDR: "0x407F7a2F61E5bAB199F7b9de0Ca330527175Da93",
    WANT_SYMBOL: "USDT-ETHK CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  sushikusdtche: {
    TITLE: "SUSHIK-USDT CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x046659BF81dbFc66CeB7Deb40513a51f22676C65",
    WANT_ADDR: "0x0AA8c12b3E3F32b58D5BD2b8043587aB646D2E10",
    WANT_SYMBOL: "SUSHIK-USDT CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  usdtetckche: {
    TITLE: "USDT-ETCK CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x435e76331E0e7878fBD82330F63dFe5c76488582",
    WANT_ADDR: "0xA108d720dcF957A93e5ffC2546924F31e5DcEC1a",
    WANT_SYMBOL: "USDT-ETCK CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  usdtunikche: {
    TITLE: "USDT-UNIK CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0xa24410f570Bb669B059a51d816C46a89a6803D6A",
    WANT_ADDR: "0x6F42c87EfF17e3303fa9994A254A477474228CeC",
    WANT_SYMBOL: "USDT-UNIK CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  usdtdotkche: {
    TITLE: "USDT-DOTK CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x700776036e6892Cb2D29767c1F12E344aeeb6d7d",
    WANT_ADDR: "0x121f3Cb1c85682837A5aeF80aef187A27747c50c",
    WANT_SYMBOL: "USDT-DOTK CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  usdtlinkkche: {
    TITLE: "USDT-LINKK CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x08D31621AB43256BF518176Afb24C8a6f882f4f1",
    WANT_ADDR: "0xCC849A4b181B0F3bDa74c1b911b2B16AF4b6EdC4",
    WANT_SYMBOL: "USDT-LINKK CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  usdtfilkche: {
    TITLE: "USDT-FILK CheLP yVault",
    LOGO: "",
    VAULT_TYPE: "yearn",
    VAULT_ABI: yVaultV2,
    VAULT_ADDR: "0x85b0a597E81abc5f3719F545510eB40eD8f5f29D",
    WANT_ADDR: "0x1288c1518806d91CB2b7c32Ef75327355A9b7590",
    WANT_SYMBOL: "USDT-FILK CLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    LP_VAULT: true,
    CHAIN_ID: 66,
  },
  busdFortress: {
    // route path
    TITLE: "BUSD Fortress",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x0980FDfCEC071ea070a991fBdD1900280cD66c11",
    WANT_ADDR: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
    WANT_SYMBOL: "BUSD",
    COINGECKO_SYMBOL: "binance-usd",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "vai-vault": {
    TITLE: "VAI Vault",
    LOGO: "🏆",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xad6b79f4Beaef46DEad4b6A4188fd7c14Bf07c57",
    WANT_ADDR: "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
    WANT_SYMBOL: "VAI",
    COINGECKO_SYMBOL: "vai",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  egg: {
    TITLE: "EGG Vault",
    LOGO: "🥚",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xe99EA79F9C3BF03Fe7D0F76dbf6c9DCC738Eb26F",
    WANT_ADDR: "0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6",
    WANT_SYMBOL: "EGG",
    COINGECKO_SYMBOL: "goose-finance",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  wbnb: {
    TITLE: "WBNB Vault",
    LOGO: "🟡",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xE1CBDCDbcf7F8Fa6Dca9c1406d0bf27C308890Ec",
    WANT_ADDR: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    WANT_SYMBOL: "WBNB",
    COINGECKO_SYMBOL: "wbnb",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "icream-bnb": {
    TITLE: "iCream BNB",
    LOGO: "🍨",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x9A6ddBe926f01ecd0c51CBAdABFE01Dfd0D417D9",
    WANT_ADDR: "0x792a46f30f1F6208b24C8199C3F2403f2Df06637",
    WANT_SYMBOL: "ICLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  brew: {
    TITLE: "Brew Vault",
    LOGO: "🍺",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x07409eC5a1a8309067223409926b32acED85f91B",
    WANT_ADDR: "0x790Be81C3cA0e53974bE2688cDb954732C9862e1",
    WANT_SYMBOL: "BREW",
    COINGECKO_SYMBOL: "cafeswap-token",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "another-icream-bnb": {
    TITLE: "Another iCream BNB",
    LOGO: "🍦",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xde5119aD6FA09c5F6A0E7c62bb56cdf44031d917",
    WANT_ADDR: "0x792a46f30f1F6208b24C8199C3F2403f2Df06637",
    WANT_SYMBOL: "ICLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  nyanethlp: {
    TITLE: "Nyan ETH LP",
    LOGO: "🐱",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x72B6389294c96D84122B65a7F01d73B08B5DBD42",
    WANT_ADDR: "0xff2282AddF0a04b949806D23EA3C992ADdcda750",
    WANT_SYMBOL: "Cake-LP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "yetanothericream-bnb": {
    TITLE: "Yet Another iCream BNB",
    LOGO: "🍧",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x3b2679c9AECf2111ea0169F6e5d21976EDB0E27A",
    WANT_ADDR: "0x792a46f30f1F6208b24C8199C3F2403f2Df06637",
    WANT_SYMBOL: "ICLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  smoke: {
    TITLE: "Smoke Vault",
    LOGO: "💨",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x005Ad6Db36161526100711fE2F359e9Ed9893aae",
    WANT_ADDR: "0x5239fE1A8c0b6ece6AD6009D15315e02B1E7c4Ea",
    WANT_SYMBOL: "SMOKE",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  icreamstake: {
    TITLE: "iCream Stake",
    LOGO: "🍨",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xDD715A2537aAc71317e07BF28655DA51f0897Bd7",
    WANT_ADDR: "0x58f651DDE51CAa87c4111B16ee0A6Fab061Ee564",
    WANT_SYMBOL: "iCream",
    COINGECKO_SYMBOL: "icecream-finance",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "taco-bnb-lp": {
    TITLE: "Taco BNB LP",
    LOGO: "🌮",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x825fa148Fc45e6A79441746d4dD5379272EEdb8c",
    WANT_ADDR: "0x5590d45592C846DD820D360dd5Ba6b2610cDeeFB",
    WANT_SYMBOL: "Cake-LP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "anothernew-icream-bnb": {
    TITLE: "Another New iCream BNB",
    LOGO: "🍦",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x8aA5279EA08A699860860fd492AC6469B19baEF5",
    WANT_ADDR: "0x792a46f30f1F6208b24C8199C3F2403f2Df06637",
    WANT_SYMBOL: "ICLP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "three-eps": {
    TITLE: "3EPS Vault",
    LOGO: "⚖️",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xEe30c4d787117965c867Db395243f0a5845917fa",
    WANT_ADDR: "0xaF4dE8E872131AE328Ce21D909C74705d3Aaf452",
    WANT_SYMBOL: "3EPS",
    COINGECKO_SYMBOL: "ellipsis",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "three-eps-2": {
    TITLE: "3EPS Vault 2",
    LOGO: "⚖️2",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xC8057Fd6F7917b5398f52d861d50685E6AbbED14",
    WANT_ADDR: "0xaF4dE8E872131AE328Ce21D909C74705d3Aaf452",
    WANT_SYMBOL: "3EPS",
    COINGECKO_SYMBOL: "ellipsis",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "isoak-bnb": {
    TITLE: "iSoak BNB",
    LOGO: "💧",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x007109F96f9AA2523f283Faac074a1887EcCFF1a",
    WANT_ADDR: "0xc8FCBA816eF9B0c5bc03d9178CfCc7EF785B4f2f",
    WANT_SYMBOL: "Cake-LP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  "busd-new": {
    TITLE: "BUSD Vault",
    LOGO: "💵",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x563f3DC2D04B6C9622236F017084456Abea05602",
    WANT_ADDR: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
    WANT_SYMBOL: "BUSD",
    COINGECKO_SYMBOL: "binance-usd",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 0x38,
  },
  oriStaker: {
    // route path
    TITLE: "Ori staker",
    LOGO: "🏆🚀",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x0AFa09D87be7711B5C64A5b577F71AC9502764E0",
    WANT_ADDR: "0x0575f8738EFdA7F512e3654F277C77e80C7d2725",
    WANT_SYMBOL: "ORI",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 250,
  },
  auroraCompounder: {
    // route path
    TITLE: "Aururoa LP Comp",
    LOGO: "🏆🚀",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x870F9b977F903f6B562bdfa2430B615B379b074e",
    WANT_ADDR: "0x483D07BC99CdD1DF66F64aE0A769A70725C46fA4",
    WANT_SYMBOL: "AURORA-FTM LP",
    COINGECKO_SYMBOL: "",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 250,
  },
  fraxfantom: {
    // route path
    TITLE: "FRAX Fantom",
    LOGO: "🏆🚀",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xe3a985F3CE21281c22894883e87f21bd89b7CD4F",
    WANT_ADDR: "0xdc301622e621166BD8E82f2cA0A26c13Ad0BE355",
    WANT_SYMBOL: "FRAX",
    COINGECKO_SYMBOL: "frax",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 250,
  },
  devhugger: {
    TITLE: "DEV Hugger",
    LOGO: "👾🤗",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xFeD651936Af7e98F7F2A93c03B1E28a2DA7dfaD4",
    WANT_ADDR: "0x5cAf454Ba92e6F2c929DF14667Ee360eD9fD5b26",
    WANT_SYMBOL: "DEV",
    COINGECKO_SYMBOL: "dev",
    VAULT_DEV: "devprtcl",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  apetrumpet: {
    TITLE: "apeTrump(et)",
    LOGO: "🦧🎺",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "experiment",
    VAULT_ADDR: "0xba81fb02d5e7b94b341e82d1959c372590b852be",
    WANT_ADDR: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    WANT_SYMBOL: "nTrump",
    COINGECKO_SYMBOL: "nTrump",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  icecreath2: {
    TITLE: "iceCREATH2",
    LOGO: "🍦TH2",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x20Eb2A369b71C29FC4aFCddBbc1CAB66CCfcB062",
    WANT_ADDR: "0xcBc1065255cBc3aB41a6868c22d1f1C573AB89fd",
    WANT_SYMBOL: "CRETH2",
    COINGECKO_SYMBOL: "CRETH2",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  sushirocket: {
    TITLE: "yvSushi YFI-ETH",
    LOGO: "🍣🍬",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x27Eb83254D900AB4F9b15d5652d913963FeC35e3",
    WANT_ADDR: "0x088ee5007C98a9677165D78dD2109AE4a3D04d0C",
    WANT_SYMBOL: "SLP",
    COINGECKO_SYMBOL: "SLP",
    VAULT_DEV: "andy8052",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  daihard: {
    TITLE: "DAI Hard yVault",
    LOGO: "🏅💪",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xBFa4D8AA6d8a379aBFe7793399D3DdaCC5bBECBB",
    WANT_ADDR: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    WANT_SYMBOL: "DAI",
    COINGECKO_SYMBOL: "DAI",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  usdc: {
    TITLE: "USd Coin yVault",
    LOGO: "🇺🇸🪙",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xe2f6b9773bf3a015e2aa70741bde1498bdb9425b",
    WANT_ADDR: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    WANT_SYMBOL: "USDC",
    COINGECKO_SYMBOL: "USDC",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  yvsteth: {
    TITLE: "Lido St. Ether Vault",
    LOGO: "👼🏦",
    VAULT_ABI: LidoVault,
    VAULT_TYPE: "experiment",
    VAULT_ADDR: "0x15a2B3CfaFd696e1C783FE99eed168b78a3A371e",
    WANT_ADDR: "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
    WANT_SYMBOL: "stETH",
    COINGECKO_SYMBOL: "staked-ether",
    VAULT_DEV: "bantg",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 1,
  },
  daiironbank: {
    TITLE: "DAI Ironbank",
    LOGO: "🦾🏦",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x07dbC20B84fF63F3cc542F6A22E5a71cbA5670A4",
    WANT_ADDR: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    WANT_SYMBOL: "DAI",
    COINGECKO_SYMBOL: "dai",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  wethmaker: {
    TITLE: "WETH Maker",
    LOGO: "🖲🏰",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x6392e8fa0588CB2DCb7aF557FdC9D10FDe48A325",
    WANT_ADDR: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    WANT_SYMBOL: "WETH",
    COINGECKO_SYMBOL: "WETH",
    VAULT_DEV: "orbxball",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  stecrv: {
    TITLE: "st. Ether-ETH Pool",
    LOGO: "💧🎱",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xdCD90C7f6324cfa40d7169ef80b12031770B4325",
    WANT_ADDR: "0x06325440D014e39736583c165C2963BA99fAf14E",
    WANT_SYMBOL: "steCRV",
    COINGECKO_SYMBOL: "ethereum",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 1,
  },
  ironlender: {
    TITLE: "WETH Iron Lender",
    LOGO: "🦾💰",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xED0244B688cF059f32f45E38A6ac6E479D6755f6",
    WANT_ADDR: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    WANT_SYMBOL: "WETH",
    COINGECKO_SYMBOL: "ethereum",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 1,
  },
  mmwbtc: {
    TITLE: "Mushroom Worker",
    LOGO: "🍄🧑‍🌾",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "experiment",
    VAULT_ADDR: "0x0e8A7717A4FD7694682E7005957dD5d7598bF14A",
    WANT_ADDR: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    WANT_SYMBOL: "WBTC",
    COINGECKO_SYMBOL: "wrapped-bitcoin",
    VAULT_DEV: "mushroomsfinan1",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 1,
  },
  ecrvseth: {
    TITLE: "Egyptian God sETH/ETH",
    LOGO: "𓀀☀︎",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x0e880118C29F095143dDA28e64d95333A9e75A47",
    WANT_ADDR: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c",
    WANT_SYMBOL: "eCRV",
    COINGECKO_SYMBOL: "ethereum",
    VAULT_DEV: "matkam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "withdraw",
    CHAIN_ID: 1,
  },
  wethgenlender: {
    TITLE: "WETH Gen Lender",
    LOGO: "🧬💰",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xac333895ce1a73875cf7b4ecdc5a743c12f3d82b",
    WANT_ADDR: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    WANT_SYMBOL: "WETH",
    COINGECKO_SYMBOL: "ethereum",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 1,
  },
  susdidle: {
    TITLE: "sUSD Idle",
    LOGO: "🏆⚔️",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x3466c90017F82DDA939B01E8DBd9b0f97AEF8DfC",
    WANT_ADDR: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
    WANT_SYMBOL: "sUSD",
    COINGECKO_SYMBOL: "nusd",
    VAULT_DEV: "emilianobonassi",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 1,
  },
  creamyswords: {
    TITLE: "Creamy Swords SNX",
    LOGO: "🍦⚔️",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x7356f09c294cb9c6428ac7327b24b0f29419c181",
    WANT_ADDR: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
    WANT_SYMBOL: "SNX",
    COINGECKO_SYMBOL: "havven",
    VAULT_DEV: "jmonteer23",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 1,
  },
  spadavault: {
    TITLE: "SpadaVault",
    LOGO: "s🦡",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x1Ae8Ccd120A05080d9A01C3B4F627F865685D091",
    WANT_ADDR: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    WANT_SYMBOL: "WBTC",
    COINGECKO_SYMBOL: "wrapped-bitcoin",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "stealth",
    CHAIN_ID: 1,
  },
  fantomsfury: {
    TITLE: "Fantom's Fury",
    LOGO: "👻⚡",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x36e7aF39b921235c4b01508BE38F27A535851a5c",
    WANT_ADDR: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83",
    WANT_SYMBOL: "WFTM",
    COINGECKO_SYMBOL: "fantom",
    VAULT_DEV: "poolpitako",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 250,
  },
  fantomsdollar: {
    TITLE: "Fantom's Dollar",
    LOGO: "👻💵",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x4b2de374d480efa96cb093cefcca23d97903a6ea",
    WANT_ADDR: "0xAd84341756Bf337f5a0164515b1f6F993D194E1f",
    WANT_SYMBOL: "fUSD",
    COINGECKO_SYMBOL: "usd-coin",
    VAULT_DEV: "poolpitako",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 250,
  },
  hotcoins: {
    TITLE: "HotCoins Vault",
    LOGO: "🔥🪙",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xBF7AA989192b020a8d3e1C65a558e123834325cA",
    WANT_ADDR: "0x0316eb71485b0ab14103307bf65a021042c6d380",
    WANT_SYMBOL: "HBTC",
    COINGECKO_SYMBOL: "huobi-btc",
    VAULT_DEV: "arbingsam",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "stealth",
    CHAIN_ID: 1,
  },
  "1inch": {
    TITLE: "1Inch Little Horse",
    LOGO: "🤏🐴",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0xb8c3b7a2a618c552c23b1e4701109a9e756bab67",
    WANT_ADDR: "0x111111111117dc0aa78b770fa6a738034120c302",
    WANT_SYMBOL: "1INCH",
    COINGECKO_SYMBOL: "1inch",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 1,
  },
  fullmetalfarmer: {
    TITLE: "Full Metal Farmer",
    LOGO: "🧙‍♂️🧪",
    VAULT_ABI: yVaultV2,
    VAULT_TYPE: "yearn",
    VAULT_ADDR: "0x56A5Fd5104a4956898753dfb060ff32882Ae0eb4",
    WANT_ADDR: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
    WANT_SYMBOL: "ALCX",
    COINGECKO_SYMBOL: "alchemix",
    VAULT_DEV: "akshaynexust",
    BLOCK_ACTIVATED: 1606599919,
    VAULT_STATUS: "active",
    CHAIN_ID: 1,
  },
});
